import { render, staticRenderFns } from "./ComponentPaginationProcess.vue?vue&type=template&id=2c48b72f&scoped=true"
import script from "./ComponentPaginationProcess.vue?vue&type=script&lang=js"
export * from "./ComponentPaginationProcess.vue?vue&type=script&lang=js"
import style0 from "./ComponentPaginationProcess.vue?vue&type=style&index=0&id=2c48b72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48b72f",
  null
  
)

export default component.exports